/* eslint-disable max-len */
import PropTypes from 'prop-types'

export const Members = ({ style, className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
    <g clipPath="url(#clip0)">
      <path d="M17.1131 10.6766H15.5664C15.7241 11.1082 15.8102 11.574 15.8102 12.0595V17.9053C15.8102 18.1077 15.775 18.302 15.7109 18.4827H18.2679C19.2231 18.4827 20.0002 17.7056 20.0002 16.7504V13.5637C20.0002 11.9717 18.7051 10.6766 17.1131 10.6766Z" fill="#933EC5"/>
      <path d="M4.19005 12.0595C4.19005 11.574 4.27618 11.1082 4.43384 10.6766H2.88712C1.29516 10.6766 0 11.9717 0 13.5637V16.7505C0 17.7056 0.777072 18.4827 1.73227 18.4827H4.28938C4.22528 18.3019 4.19005 18.1077 4.19005 17.9053V12.0595Z" fill="#933EC5"/>
      <path d="M11.7679 9.17249H8.23184C6.63988 9.17249 5.34473 10.4676 5.34473 12.0596V17.9053C5.34473 18.2242 5.60324 18.4827 5.92215 18.4827H14.0775C14.3964 18.4827 14.655 18.2242 14.655 17.9053V12.0596C14.655 10.4676 13.3598 9.17249 11.7679 9.17249Z" fill="#933EC5"/>
      <path d="M9.99994 1.51721C8.08541 1.51721 6.52783 3.07479 6.52783 4.98937C6.52783 6.288 7.24459 7.42218 8.30311 8.01765C8.80518 8.30008 9.384 8.46148 9.99994 8.46148C10.6159 8.46148 11.1947 8.30008 11.6968 8.01765C12.7553 7.42218 13.472 6.28796 13.472 4.98937C13.472 3.07483 11.9145 1.51721 9.99994 1.51721Z" fill="#933EC5"/>
      <path d="M3.90284 4.75348C2.471 4.75348 1.30615 5.91832 1.30615 7.35016C1.30615 8.782 2.471 9.94685 3.90284 9.94685C4.26604 9.94685 4.6119 9.87161 4.92608 9.73638C5.46929 9.50251 5.91718 9.08853 6.19433 8.56997C6.38886 8.20602 6.49952 7.79083 6.49952 7.35016C6.49952 5.91836 5.33468 4.75348 3.90284 4.75348Z" fill="#933EC5"/>
      <path d="M16.0972 4.75348C14.6653 4.75348 13.5005 5.91832 13.5005 7.35016C13.5005 7.79087 13.6112 8.20606 13.8057 8.56997C14.0828 9.08857 14.5307 9.50255 15.0739 9.73638C15.3881 9.87161 15.734 9.94685 16.0972 9.94685C17.529 9.94685 18.6939 8.782 18.6939 7.35016C18.6939 5.91832 17.529 4.75348 16.0972 4.75348Z" fill="#933EC5"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>

)

Members.propTypes = {
  style: PropTypes.instanceOf(Object),
  className: PropTypes.string
}

Members.defaultProps = {
  style: {},
  className: undefined
}
